export const getUploadedRegistry = state => state.uploadedRegistry;
